import React, { ReactNode, useState } from "react";
import { useProjectStore } from "@/stores/projectStore";
import SingleProjetHeader from "@/components/myProjectsComp/SingleProjetHeader";
import Tabs from "@/components/myProjectsComp/ProjectTabs";
import ProjectIconButton from "@/components/myProjectsComp/ProjectIconButton";

import { MenuItem } from "@/stores";
import { PaperAirplaneIcon } from "@heroicons/react/24/outline";

interface SingleProjetProps {
  children: ReactNode;
}

const SingleProjet: React.FC<SingleProjetProps> = ({ children }) => {
  const { selectedProject } = useProjectStore();

  const [activeTab, setActiveTab] = useState(0);

  const menuItems: MenuItem[] = [
    { name: "Général", path: "/jeuneInnovateur/mesProjets/singleProjet" },
    { name: "Tâches", path: "/jeuneInnovateur/mesProjets/singleProjet/taches" },
    {
      name: "Discussions",
      path: "/jeuneInnovateur/mesProjets/singleProjet/dicussions",
      notificationCount: 3,
    },
    {
      name: "Membres",
      path: "/jeuneInnovateur/mesProjets/singleProjet/membres",
    },
    {
      name: "Notifications",
      path: "/jeuneInnovateur/mesProjets/singleProjet/notifications",
      notificationCount: 12,
    },
    {
      name: "Fichiers",
      path: "/jeuneInnovateur/mesProjets/singleProjet/fichiers",
    },
    {
      name: "Intégrations",
      path: "/jeuneInnovateur/mesProjets/singleProjet/integrations",
    },
  ];

  if (!selectedProject) {
    return <div>No project selected</div>;
  }

  return (
    <div className=" border-t bg-slate-100">
      <div className="p-1 flex justify-between">
        <div>
          <SingleProjetHeader
            logo={
              selectedProject.logoUrl
                ? selectedProject.logoUrl
                : "/images/project.png"
            }
            title={selectedProject.title}
            subtitle=""
          />
          <Tabs
            tabs={menuItems}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>
        <div className="mt-4">
          <ProjectIconButton
            label="Soumettre le projet"
            icon={
              <PaperAirplaneIcon className="h-5 w-5 text-rajapiGreen rotate-[300deg]	" />
            }
          />
        </div>
      </div>
      <main className="flex flex-grow p-4">{children}</main>
    </div>
  );
};

export default SingleProjet;
